var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-nav dashboard--nav" }, [
    _c("div", { staticClass: "header-top-content" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c(
          "div",
          {
            staticClass:
              "flex header-right d-flex align-items-center justify-content-start",
          },
          [
            _c("i", {
              staticClass: "la la-solid la-bars la-2x ml-2",
              staticStyle: { color: "whitesmoke" },
              on: {
                click: function ($event) {
                  return _vm.toggleMenu()
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "header-right d-flex align-items-center justify-content-end mr-3",
          },
          [
            _c(
              "div",
              {
                staticClass: "header-right-action",
                staticStyle: {
                  border: "0.5px solid #ffffff",
                  "border-radius": "5px",
                  padding: "6px",
                  "padding-left": "17px",
                  "margin-right": "20px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "select-contain select--contain w-auto top-lang",
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.locale,
                            expression: "locale",
                          },
                        ],
                        staticClass: "select-contain-select lang-select",
                        staticStyle: { color: "whitesmoke" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.locale = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            attrs: {
                              "data-content":
                                '<span class="flag-icon flag-icon-us mr-1"></span> English',
                            },
                            domProps: {
                              value: "EN",
                              selected: _vm.locale === "EN",
                            },
                          },
                          [_vm._v("English")]
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          {
                            attrs: {
                              "data-content":
                                '<span class="flag-icon flag-icon-tr mr-1"></span> Türkçe',
                            },
                            domProps: {
                              value: "TR",
                              selected: _vm.locale === "TR",
                            },
                          },
                          [_vm._v("Türkçe")]
                        ),
                        _vm._v(" "),
                        _vm.projectName === "selectum"
                          ? _c(
                              "option",
                              {
                                attrs: {
                                  "data-content":
                                    '<span class="flag-icon flag-icon-ru mr-1"></span> Rusça',
                                },
                                domProps: {
                                  value: "RU",
                                  selected: _vm.locale === "RU",
                                },
                              },
                              [_vm._v("Rusça")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.projectName === "selectum"
                          ? _c(
                              "option",
                              {
                                attrs: {
                                  "data-content":
                                    '<span class="flag-icon flag-icon-de mr-1"></span> Almanca',
                                },
                                domProps: {
                                  value: "DE",
                                  selected: _vm.locale === "DE",
                                },
                              },
                              [_vm._v("Almanca")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.user !== null
              ? _c("div", { staticClass: "header-right-action" }, [
                  _c(
                    "span",
                    {
                      staticClass: "font-size-14 font-weight-bold",
                      staticStyle: { color: "whitesmoke" },
                    },
                    [_vm._v(_vm._s(_vm.user.email))]
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }